import { motion } from "framer-motion";
import { STAGES } from "@/lib/content";
import { SectionHead } from "@/components/site/SectionHead";
import { LinkButton } from "@/components/site/LinkButton";
import { Petal } from "@/components/site/Petal";

const Stage = ({ s, i }) => (
  <motion.li
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay: 0.2 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
    data-testid={`journey-stage-${s.name.toLowerCase()}`}
    className="relative flex gap-6 pb-12 last:pb-0 lg:flex-col lg:items-center lg:gap-0 lg:pb-0 lg:text-center"
  >
    <div className="relative z-10 flex h-16 w-16 shrink-0 items-center justify-center rounded-full border border-[#e4dacb] bg-[#faf5ee] lg:h-20 lg:w-20">
      <Petal color={s.color} size={26} />
    </div>
    <div className="lg:mt-6">
      <span className="text-xs font-semibold tracking-[0.2em] text-[#5d544c]">{s.n}</span>
      <h3 className="font-display mt-1 text-3xl text-[#221e1b]">{s.name}</h3>
      <p className="mt-1 text-sm italic text-[#7a5615]">{s.kosha}</p>
      <p className="mt-3 max-w-[15rem] text-sm leading-relaxed text-[#5d544c] lg:mx-auto">{s.short}</p>
    </div>
  </motion.li>
);

export const JourneyPreview = () => (
  <section className="relative bg-[#f2ebe0] py-24 md:py-32" data-testid="journey-preview">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <SectionHead
          eyebrow="The 21-day coaching journey (coming soon)"
          title="A journey through five layers of yourself"
          text="The ancient idea of the five koshas describes us in layers, from the outer body to an inner sense of wholeness. The coaching journey moves through them one at a time, from the most tangible to the most subtle."
        />
      </div>
      <div className="relative mt-20">
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
          className="journey-line absolute left-[10%] right-[10%] top-10 hidden h-px origin-left lg:block"
        />
        <div className="journey-line-v absolute bottom-8 left-8 top-8 w-px lg:hidden" />
        <ol className="relative grid lg:grid-cols-5 lg:gap-6">
          {STAGES.map((s, i) => <Stage key={s.n} s={s} i={i} />)}
        </ol>
      </div>
      <div className="mt-16 flex justify-center sm:justify-start lg:justify-center">
        <LinkButton to="/journey" testId="journey-explore-btn">Explore the Journey</LinkButton>
      </div>
    </div>
  </section>
);
